export default __webpack_public_path__ + "static/media/Two Buttons.bc6d691f.svg";